export function formatWeekdayDate(date, locale) {
    const theDate = new Date(date);
    const options = {
        weekday: 'short',
        day: '2-digit',
        month: '2-digit',
    };
    return theDate.toLocaleDateString(locale, options).toUpperCase();
}

export function formatWeekdayDateCz(date) {
    return formatWeekdayDate(date, 'cs-CZ');
}
